import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Alert, Button, Empty, Message, Table, Tag, Tooltip } from "@arco-design/web-react";
import { IconDelete, IconPlus } from "@arco-design/web-react/icon";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Content from "../Layout/Content";
import BroadcastDialog from "./BroadcastDialog";
import SummaryCard from "../Layout/SummaryCard";
import ArchiveBroadcastDialog from "./BroadcastViewer/ArchiveBroadcastDialog";

import { useAuth0 } from '@auth0/auth0-react';
import { DeleteApi, FetchApi, PostApi } from '../Api/AuthenticatedApi';
import OrganizationEmails from "../Settings/OrganizationEmails/OrganizationEmails";
import SimpleBreadcrumbs from "../Components/Breadcrumbs/SimpleBreadcrumbs";
import { broadcastStatusMeta } from "./broadcastStats";

// MUI -> Arco. makeStyles -> styled-components. The MUI Table/TableHead/
// TableBody/TableRow/TableCell + TablePagination JSX is rewritten into an Arco
// Table with a columns config + data array and Arco's pagination. The select-all
// header checkbox and per-row selection were already commented out in the
// original, so the EnhancedTableHead + selection helpers are dropped. Sorting was
// a no-op (handleRequestSort only logged), so column titles have no functional
// sorter. CircularProgress -> Spin (Table loading); Toolbar/Paper -> styled divs;
// Snackbar+Alert -> Arco Alert shown when open; AddIcon -> IconPlus, DeleteIcon
// -> IconDelete; Button contained -> type="primary".

const Toolbar = styled.div`
    display: flex;
    align-items: center;
    min-height: 64px;
    padding: 0 8px;
`;

const Grow = styled.div`
    flex-grow: 1;
`;

const DeleteButtonWrap = styled.div`
    margin-left: 8px;
`;

const columns = [
    { title: "Name", dataIndex: "name" },
    {
        title: "Status",
        dataIndex: "status",
        render: (status) => {
            const meta = broadcastStatusMeta(status);
            return <Tag color={meta.color}>{meta.label}</Tag>;
        },
    },
    {
        title: "Date",
        dataIndex: "created_date",
        render: (createdDate) => (createdDate ? moment(createdDate).format("MMM D, YYYY") : ""),
    },
];

const ROWS_PER_PAGE = 10;

export default function Broadcasts() {
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [isDataUpdated, setIsDataUpdated] = useState(false);

    const error = false;
    // todo with snacks
    const [snackOpen, setSnackOpen] = React.useState(false);

    let history = useNavigate();
    const { getAccessTokenSilently } = useAuth0();

    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchBroadcasts = () => {
        setLoading(true);
        FetchApi(getAccessTokenSilently,
            "/api/broadcasts/?" + new URLSearchParams({ page: page, count: rowsPerPage }),
            (data) => {
                setLoading(false);
                setRows((data && data.broadcasts) || []);
                setTotalCount((data && data.total_count) || 0);
            },
            (response) => {
                setLoading(false);
                history("/login");
            }, (response) => {
                setLoading(false);
                Message.error("Failed to load broadcasts");
            })
    }

    useEffect(() => {
        fetchBroadcasts()
    }, [history, rowsPerPage, page, getAccessTokenSilently])

    // console.log("Setting up Campaigns!")

    if (error) return `Error! ${error.message}`;
    // if (error) return `Error! ${error.message}`;

    // const handleRequestSort = (event, property) => {
    //   const isAsc = orderBy === property && order === "asc";
    //   setOrder(isAsc ? "desc" : "asc");
    //   setOrderBy(property);
    // };
    const handleBroadcastAdded = (broadcastRecord) => {
        setLoading(true);

        PostApi(getAccessTokenSilently,
            "/api/broadcasts/",
            (data) => {
                setLoading(false);
                Message.success("Broadcast created");
                // setRows(data);
                fetchBroadcasts();
                setIsDataUpdated((prevIsDataUpdated) => !prevIsDataUpdated);

            },
            (response) => {
                setLoading(false);
                history("/login");
            }, (response) => {
                setLoading(false);
                Message.error("Failed to create broadcast");
            }, broadcastRecord)
    }

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (theRowsPerPage) => {
        setRowsPerPage(theRowsPerPage);
        setPage(0);
    };

    const snackClose = () => {
        setSnackOpen(false);
    };

    return (
        <Content>
            {/* <div
                style={{
                    height: "200px",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    filter: "contrast(75%)",
                    backgroundImage: "url(/img/wallpaper.jpeg)",
                }}
            /> */}

            <div>
                <SimpleBreadcrumbs
                    elements={
                        [
                            { name: 'Broadcasts' },

                        ]
                    }

                />
            </div>


            {snackOpen && (
                <Alert type="success" closable onClose={snackClose} content={snackOpen} />
            )}

            <Toolbar>
                <Grow />
                <BroadcastDialog
                    // onSave={() => {
                    //     setSnackOpen("Campaign added");
                    // }}
                    onSave={(broadcastRecord) => {
                        // if (!contactRecord.name || !contactRecord.email) {
                        //     console.log("Failed to get contact back! No save for you.")
                        //     return
                        // }
                        // setIsDataUpdated((prevIsDataUpdated) => !prevIsDataUpdated);

                        handleBroadcastAdded(broadcastRecord);
                        // setSnackOpen("Contact added");
                    }}
                    render={(open) => (
                        <div>
                            <Button
                                type="primary"
                                icon={<IconPlus />}
                                onClick={open}
                            >
                                Add Broadcast
                            </Button>
                        </div>
                    )}
                />
                {false /* I don't think we want archiving here */ && selected.length > 0 && (
                    <Tooltip content={"Archive"}>
                        <React.Fragment>
                            {/*TODO(Eric Harrison): make this for archive */}
                            <ArchiveBroadcastDialog
                                ids={selected}
                                onSave={() => {
                                    // dispatch(handleRemoveClick(selected));
                                    // setSnackOpen(
                                    //     `${selected.length} Campaign${selected.length > 1 ? "s" : ""
                                    //     } Archived`
                                    // );
                                    setSelected([]);
                                }}
                                render={(open) => (
                                    <DeleteButtonWrap>
                                        <Button
                                            type="primary"
                                            status="danger"
                                            icon={<IconDelete />}
                                            onClick={open}
                                        >
                                            {" "}
                                            Archive {selected.length} selected
                                        </Button>
                                    </DeleteButtonWrap>
                                )}
                            />
                        </React.Fragment>
                    </Tooltip>

                )}
            </Toolbar>


            <SummaryCard
                title={"Broadcasts"}
                subTitle={"Create one-time email blasts"}
            >
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    data={rows || []}
                    loading={loading}
                    noDataElement={
                        <Empty description="No broadcasts yet">
                            <BroadcastDialog
                                onSave={(broadcastRecord) => {
                                    handleBroadcastAdded(broadcastRecord);
                                }}
                                render={(open) => (
                                    <Button type="primary" style={{ marginTop: 12 }} onClick={open}>
                                        Create your first broadcast
                                    </Button>
                                )}
                            />
                        </Empty>
                    }
                    onRow={(row) => ({
                        style: { cursor: "pointer" },
                        onClick: () => {
                            history(`/broadcasts/${row.id}/view`);
                        },
                    })}
                    pagination={{
                        current: page + 1,
                        pageSize: rowsPerPage,
                        total: totalCount,
                        sizeCanChange: true,
                        pageSizeChangeResetCurrent: true,
                        sizeOptions: [5, 10, 25],
                        onChange: (current, pageSize) => {
                            if (pageSize !== rowsPerPage) {
                                handleChangeRowsPerPage(pageSize);
                            } else {
                                handleChangePage(current - 1);
                            }
                        },
                    }}
                />
            </SummaryCard>

        </Content>
    );
}
